import OtherInformation from './OtherInformation';

export default OtherInformation;
